import configAccessibilityGetters from './configGetters/configAccessibilityGetters';
import configAppGetters from './configGetters/configAppGetters';
import configAppLinksGetters from './configGetters/configAppLinksGetters';
import configAwsGetters from './configGetters/configAwsGetters';
import configDeviceConnectionType from './configGetters/configDeviceConnectionType';
import configDeviceSupportGetters from './configGetters/configDeviceSupportGetters';
import configExternalLinksGetters from './configGetters/configExternalLinksGetters';
import configFwGetters from './configGetters/configFwGetters';
import configGamGetters from './configGetters/configGamGetters';
import configIccConsumerServicesGetter from './configGetters/configIccConsumerServicesGetter';
import configIccGetters from './configGetters/configIccGetters';
import configLocalizationGetters from './configGetters/configLocalizationGetters';
import configLoginGetters from './configGetters/configLoginGetters';
import configLogsGetters from './configGetters/configLogsGetters';
import configScpGetters from './configGetters/configScpGetters';
import configStorageGetters from './configGetters/configStorageGetters';
import configUnmarkedGetters from './configGetters/configUnmarkedGetters';

export default {
    ...configAccessibilityGetters,
    ...configAppGetters,
    ...configAppLinksGetters,
    ...configAwsGetters,
    ...configDeviceSupportGetters,
    ...configExternalLinksGetters,
    ...configFwGetters,
    ...configGamGetters,
    ...configIccConsumerServicesGetter,
    ...configIccGetters,
    ...configLocalizationGetters,
    ...configLoginGetters,
    ...configLogsGetters,
    ...configScpGetters,
    ...configStorageGetters,
    ...configUnmarkedGetters,
    ...configDeviceConnectionType,
};
